module.exports = __webpack_public_path__ + "img/MerchantRedirectUPS.f9bb581e.svg";